import React, { useState,useEffect } from 'react'
import styles from "./MobileTabScience.module.css"
import Modal from '../../ModalSciencePage/Modal';
import ProductsData from "../../../../../json/products.json";
import { getProduct, getSubscription } from "@/data/lib";
import ProductsReviewData from "../../../../../json/productReviews.json";
import PurchaseBox from "@/utilities/PurchaseBox";


const MobileTabScience = ({data}) => {


   const {tabData} = data
  const [load, setLoad] = useState(true);
  const [product, setProduct] = useState();
  const [shopifyP, setSProduct] = useState();
  const [rechargeProduct, setRProduct] = useState();
  let ReviewData = {};
  const [activeTab, setActiveTab] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(1);
  const [isVisible, setIsVisible] = useState(false);
  const [modalImage, setModalImage] = useState('/images/modalImgBrunoMd (1).webp');
  const [modalTitle, setModalTitle] = useState('Royal Collagen Peptides');
  const [modalsubTitle, setModalsubTitle] = useState('The Science of Beauty');

  var { theme, EXTERNALID, STOREFRONTID, SLUG, priceBox } = product || {};

  useEffect(() => {
    if (SLUG) {
      getProdData(SLUG);
    }
  }, [SLUG]);

  const getProdData = (slug) => {
    let product = ProductsData[slug];
    if (product?.EXTERNALID) {
        ReviewData = ProductsReviewData[product?.EXTERNALID] || {};
        const productId = `gid://shopify/Product/${product.EXTERNALID}`;

        if ((EXTERNALID || product.EXTERNALID) && shopifyP?.id !== productId) {
            getProduct({ productId })
                .then((response) => {
                    let product = response?.data?.product;
                    setSProduct(product);
                    setLoad(false);
                })
                .catch((err) => {
                    console.log({ err });
                });
        }

        EXTERNALID = product.EXTERNALID;

        if (
            EXTERNALID &&
            (!rechargeProduct?.product_id || rechargeProduct?.product_id !== EXTERNALID)
        ) {
            getSubscription({ id: EXTERNALID })
                .then((data) => {
                    if (data?.plans?.length) {
                        let freq = [];
                        data.plans.forEach((element) => {
                            if (element.subscription_preferences.charge_interval_frequency) {
                                freq.push({
                                    id: element.subscription_preferences.charge_interval_frequency,
                                    value:
                                        element.subscription_preferences.charge_interval_frequency +
                                        " " +
                                        element.subscription_preferences.interval_unit,
                                });
                            }
                        });

                        freq.sort((a, b) => (a.value < b.value ? -1 : 1));

                        setRProduct({
                            product_id: EXTERNALID,
                            subscription_preferences: freq,
                        });
                    }

                    if (data?.selling_plan_groups?.length > 0) {
                        let freqs = [];
                        data.selling_plan_groups[0].selling_plans.forEach((plans) => {
                            if (plans.order_interval_frequency) {
                                freqs.push({
                                    id: `gid://shopify/SellingPlan/${plans.selling_plan_id}`,
                                    value:
                                        plans.order_interval_frequency +
                                        " " +
                                        plans.order_interval_unit_type,
                                });
                            }
                        });

                        freqs.sort((a, b) => (a.value < b.value ? -1 : 1));

                        setRProduct({
                            product_id: EXTERNALID,
                            subscription_preferences: freqs,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err.message);
                });
        }

        product.amazonReview = ReviewData;
        setProduct(product);
    }
};

  const handleOpenModal = () => {
    const selectedTab = tabData[activeTab];
    // console.log("Selected Tab Data:", selectedTab); // Debugging
    // console.log("Slug:", selectedTab.slug); // Debugging
  
    setModalImage(selectedTab.modalimage);
    setModalTitle(selectedTab.title);
    setModalsubTitle(selectedTab.subTitle);
  
    if (selectedTab.slug) {
      getProdData(selectedTab.slug);
    } else {
      console.error("Slug is undefined for the selected tab.");
    }
  
    setIsModalOpen(true);
  };
  

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // const toggleVisibility = () => {
  //   setIsVisible(!isVisible);
  // };
  // const handleRadioChange = (index) => {
  //   setActiveIndex(index);
  // };
  // Data for the tabs
 

  return (
    <div className={styles.MobTab}>
      <div className={styles.humanTabMain}>
        <div className={styles.bottelTab}>
          {tabData.slice(0, 2).map((tab, index) => (
            <div
              key={index}
              className={`${styles.TabClick} ${activeTab === index ? styles[`activeTab${index + 1}`] : ''}`}
              onClick={() => setActiveTab(index)}
            >
              <div className={`${styles.tabImgDiv} ${activeTab === index ? styles[`activeTab${index + 1}`] : ''}`}>
                <img src={tab.tabImage} alt="" />
              </div>
              <div className={styles.TabImgTitle}>
                <h1>{tab.title}</h1>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.bottelTab2}>
          {tabData.slice(2).map((tab, index) => (
            <div
              key={index + 2}
              className={`${styles.TabClick} ${activeTab === index + 2 ? styles[`activeTab${index + 3}`] : ''}`}
              onClick={() => setActiveTab(index + 2)}
            >
              <div className={`${styles.tabImgDiv} ${activeTab === index + 2 ? styles[`activeTab${index + 3}`] : ''}`}>
                <img src={tab.tabImage} alt="" />
              </div>
              <div className={styles.TabImgTitle}>
                <h1>{tab.title}</h1>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.bottelDecribtion}>
        <div className={styles.TabingDetailsDiv}>
          <div className={styles.TabimgHuman}>

            <img src={tabData[activeTab].videoSrc} alt="Active Tab GIF" className={styles.gifImage} />
          </div>
          <div className={styles.humanDecribtionDiv}>
            {tabData[activeTab].content.map((item, index) => (
              <div key={index} className={styles.humanDecribtion}>
                <h1>{item.heading}</h1>
                <p>{item.description}</p>
                <div className={`${styles.tabHR} ${styles[`tabHR${activeTab + 1}`]}`}></div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.mobBuybtn}>
          <button onClick={handleOpenModal}>{tabData[activeTab].buyButton}</button>
        </div>
      </div>
      <Modal show={isModalOpen} onClose={handleCloseModal}>
        <div className={styles.mainModalDiv}>

          <div className={styles.modalImg}>
            <div className={styles.modalContentData}>
              <div className={styles.brunoImgModal}>
                <img src={modalImage} alt='' />
              </div>
              <div className={styles.modaltitle}>
                <h6>{modalTitle}</h6>
                <p>{modalsubTitle}</p>
              </div>
            </div>
          </div>

          <div className={styles.modalContent}>
          {shopifyP ? (
                  <PurchaseBox
                    data={{
                      EXTERNALID,
                      STOREFRONTID,
                      SLUG,
                      price: shopifyP?.variants?.edges?.length
                        ? parseFloat(
                            shopifyP?.variants.edges[0].node?.price?.amount
                          )
                        : 0,
                      theme,
                      priceBox,
                      freq: rechargeProduct?.subscription_preferences,
                    }}
                    variantId={shopifyP?.variants.edges[0].node?.id}
                  />
                ) : (
                  ""
                )}
          </div>
        </div>

      </Modal>
    </div>
  )
}

export default MobileTabScience
